@if (!isMobile || (isMobile && !isStickyOfferBannerEnabled())) {
  <div class="w-full" id="carousel-container">
    <div
      class="relative w-full overflow-hidden"
      (touchstart)="handleSwipe($event)"
      (touchend)="handleSwipe($event)"
      >
      <div
        class="flex transition-transform duration-300 ease-out"
        [style.transform]="'translateX(-' + index() * 100 + '%)'"
        >
        @for (offer of sortedOffers(); track $index; let i = $index) {
          <div
            class="min-w-full w-full flex items-stretch justify-start carousel-offer"
            [style.max-height]="index() === i ? 'initial' : '0'"
            >
            <ng-container
              [ngTemplateOutlet]="slideTemplate"
              [ngTemplateOutletContext]="{ $implicit: offer }"
            ></ng-container>
          </div>
        }
      </div>
    </div>

    @if (showDots()) {
      <div class="flex items-center justify-center mt-4 gap-8">
        <!-- Prev -->
        <button
          type="button"
          class="bg-transparent border-none p-0 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
          (click)="prev()"
          [disabled]="!canGoPrev()"
          aria-label="Previous slide"
          >
          <svg class="arrow w-5 h-5 m-0 p-0 text-navy-900">
            <use href="assets/icons-v2/sprites.svg#chevron-left"></use>
          </svg>
        </button>

        <div class="flex gap-1.5 items-center">
          @for (offer of sortedOffers(); track $index; let i = $index) {
            <button
              type="button"
              class="h-2 w-2 rounded-full border-2 cursor-pointer transition-all"
              [ngClass]="
                i === index()
                  ? 'bg-slate-700 border-slate-700'
                  : 'bg-transparent border-slate-700'
              "
              aria-label="Go to slide {{ i + 1 }}"
              (click)="goTo(i)"
            ></button>
          }
        </div>

        <!-- Next -->
        <button
          type="button"
          class="bg-transparent border-none p-0 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
          (click)="next()"
          [disabled]="!canGoNext()"
          aria-label="Next slide"
          >
          <svg class="arrow w-5 h-5 m-0 p-0 text-navy-900">
            <use href="assets/icons-v2/sprites.svg#chevron-right"></use>
          </svg>
        </button>
      </div>
    }
  </div>
} @else if (isMobile && isStickyOfferBannerEnabled()) {
  <section
    id="sticky-offer-carousel"
    class="mobile-fix-container"
    [ngClass]="{
      'transition-from-bottom': scrolled,
      'transition-to-bottom': !scrolled,
    }"
    >
    <div class="loan-offer pop-up">
      <button (click)="onCloseOfferClick()" class="close-button">
        <svg
          class=""
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.29292 5.29292C5.68345 4.9024 6.31661 4.9024 6.70714 5.29292L19.4813 18.0671C19.8719 18.4576 19.8719 19.0908 19.4813 19.4813C19.0908 19.8719 18.4576 19.8719 18.0671 19.4813L5.29292 6.70714C4.9024 6.31661 4.9024 5.68345 5.29292 5.29292Z"
            fill="#000"
            />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.29289 19.4813C4.90237 19.0908 4.90237 18.4576 5.29289 18.0671L18.0671 5.2929C18.4576 4.90238 19.0908 4.90238 19.4813 5.2929C19.8718 5.68343 19.8718 6.31659 19.4813 6.70711L6.70711 19.4813C6.31658 19.8718 5.68342 19.8718 5.29289 19.4813Z"
            fill="#000"
            />
        </svg>
      </button>

      <div
        class="carousel-outer"
        (touchstart)="handleSwipe($event)"
        (touchend)="handleSwipe($event)"
        >
        @for (offer of sortedOffers(); track offer; let i = $index) {
          <div
            class="text-container"
            [style.transform]="getTranslationValue()"
            >
            <h2 class="heading mb-1">
              {{ offer.heading }}
              @if (shouldShowMinAprInTitle(offer)) {
                {{ offer.minApr | number: '1.2-2' }}%
              } @else if (
                offer?.subProductType === 'SECURED_HOME_LOAN' && offer?.minApr
              ) {
                {{ offer.minApr | number: '1.2-2' }}%
              } @else if (
                offer?.subProductType === 'UNSECURED_LOAN' && offer?.maxAmount
              ) {
                {{ offer.maxAmount | currency: 'USD' : 'symbol' : '1.0-0' }}
              }
            </h2>
            @if (offer?.approvalBadge) {
              <app-approval-chance
                class="text-center"
                [approval]="offer?.approvalBadge"
                [disclosure]="offer?.approvalDisclosure"
                [direction]="direction"
                [alignment]="isStickyOfferBannerEnabled() ? 'center' : ''"
              ></app-approval-chance>
            }
            <p>
              <button (click)="onDisclosureClick()" class="disclosure-button">
                {{ offer.label }}
              </button>
            </p>
            <div class="offer-btn-group">
              @if (offer.offerType !== 'RESUME_APPLICATION') {
                <button
                  (click)="onApply()"
                  class="mobile-cta-button mobile-cta-button--wide"
                  >
                  {{ offer.callToAction }}
                </button>
              }
              @if (
                offer.offerType !== 'RESUME_APPLICATION' &&
                offer.subProductType === 'SECURED_HOME_LOAN'
                ) {
                <button
                  class="mobile-cta-button mobile-cta-button--ghost min-w-24 whitespace-nowrap"
                  (click)="handleLearnMoreClick(offer)"
                  >
                  Learn more
                </button>
              }
            </div>
          </div>
        }
      </div>
    </div>

    @if (showDots()) {
      <div class="flex items-center justify-center mt-4 gap-8">
        <!-- Prev -->
        <button
          type="button"
          class="bg-transparent border-none p-0 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
          (click)="prev()"
          [disabled]="!canGoPrev()"
          aria-label="Previous slide"
          >
          <svg class="arrow w-5 h-5 m-0 p-0 text-navy-900">
            <use href="assets/icons-v2/sprites.svg#chevron-left"></use>
          </svg>
        </button>

        <div class="flex gap-1.5 items-center">
          @for (offer of sortedOffers(); track $index; let i = $index) {
            <button
              type="button"
              class="h-2 w-2 rounded-full border-2 cursor-pointer transition-all"
              [ngClass]="
                i === index()
                  ? 'bg-slate-700 border-slate-700'
                  : 'bg-transparent border-slate-700'
              "
              aria-label="Go to slide {{ i + 1 }}"
              (click)="goTo(i)"
            ></button>
          }
        </div>

        <!-- Next -->
        <button
          type="button"
          class="bg-transparent border-none p-0 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
          (click)="next()"
          [disabled]="!canGoNext()"
          aria-label="Next slide"
          >
          <svg class="arrow w-5 h-5 m-0 p-0 text-navy-900">
            <use href="assets/icons-v2/sprites.svg#chevron-right"></use>
          </svg>
        </button>
      </div>
    }
  </section>
}
